import { MdInfoOutline } from "react-icons/md";
import { SanitizedContent } from "@/common/components-2/sanitized-content";
import { isNil } from "@/common/helpers/lang";
import { getAnnotationClass, getHeadingClass, getStepClass } from "./numbered-steps-list.styles";
import type { NumberedStepsListProps } from "./numbered-steps-list.types";

const annotationExists = (annotation: string | null | undefined) => isNil(annotation) || annotation.length === 0;

export function NumberedStepsList({ heading, steps, ...props }: NumberedStepsListProps) {
  return (
    <div {...props}>
      <h2 className={getHeadingClass()}>{heading}</h2>
      <div className="mt-10 flex w-full flex-col gap-6 lg:flex-row">
        {steps.map((step, index) => (
          <div key={step.title} className={getStepClass()} style={{ animationDelay: `${index * 0.2}s` }}>
            <div className="flex items-center gap-3 lg:h-14">
              <div className="flex size-7 shrink-0 items-center justify-center rounded-full bg-tertiary-400 text-white lg:size-10 lg:text-xl">
                {index + 1}
              </div>
              <h5 className="font-bold text-lg leading-tight">{step.title}</h5>
            </div>
            <SanitizedContent
              as="div"
              content={step.description}
              className="mt-1 text-gray-600 leading-normal lg:mt-4 lg:text-lg"
            />
            {annotationExists(step.annotation) ? null : (
              <p className={getAnnotationClass()}>
                <MdInfoOutline className="text-5xl" />
                <span>{step.annotation}</span>
              </p>
            )}
          </div>
        ))}
      </div>
    </div>
  );
}
